import { gql } from '@apollo/client';

export const UPDATE_STORE = gql`
  mutation UpdateStore($userId: ID!, $store: UpdateStoreInput!) {
    updateStore(userId: $userId, store: $store) {
      __typename
      ... on UpdateStoreSuccess {
        code
        message
      }
      ... on Error {
        message
        code
      }
    }
  }
`;
